import React from 'react';
import styled from 'styled-components';
import { minBp } from 'src/lib/theme';
import { TitleBar } from './BikeFilters.styled';

export const Dialog = styled.div`
  ${({ hasButton }) => `  
    position: fixed;
    top: 60px;
    left: 0;
    height: calc(100% - 60px);
    width: 100%;
    background-color: white;
    z-index: 101;
    padding: 84px 26px ${hasButton ? '78px' : '26px'};

    @media ${minBp('tabletLarge')} {
      position: absolute;
      width: 390px;
      height: auto;
      border-radius: 4px;
      background-color: rgba(0, 0, 0, 0.9);
      padding: 18px 24px;
      top: calc(100% + 12px);
      z-index: 1;
      cursor: default;
      font-size: 14px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 11;

      &:after {
        content: ' ';
        position: absolute;
        top: -12px;
        left: 50%;
        transform: translateX(-50%);
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 0 12px 12px 12px;
        border-color: transparent transparent rgba(0, 0, 0, 0.9) transparent;
      }
    }
  `}
`;

export const DialogHeader = styled(TitleBar)`
  @media ${minBp('tabletLarge')} {
    display: none;
  }
`;

export const FilterTitle = styled.h3`
  color: #000;
  font-weight: 500;
  font-family: ${({ theme }) => theme.fonts.dinDemi};
  font-size: inherit;
  margin: 0 0 5px;

  @media ${minBp('tabletLarge')} {
    margin: 0 0 10px;
    color: white;
    font-size: inherit;
    text-transform: normal;
    background-color: transparent;
  }
`;

export const Choices = styled.div``;

export const Description = styled.div`
  margin-top: 12px;
  color: #8d8e90;

  @media ${minBp('tabletLarge')} {
    margin-top: 10px;
  }
`;

export const RangeDescription = styled.div`
  color: #8d8e90;
  margin-bottom: 12px;

  span {
    font-family: ${({ theme }) => theme.fonts.dinDemi};
    font-weight: 500;
    color: #000;
  }

  @media ${minBp('tabletLarge')} {
    span {
      color: white;
    }
  }
`;

export const ClickCatch = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
`;

export const BackButton = styled.div`
  padding: 5px;
  position: relative;
  bottom: 1px;
  left: -5px;

  svg {
    width: 16px;
    height: 16px;
    vertical-align: middle;

    path {
      fill: #585a5f;
    }
  }
`;

export const OptionsWrap = styled.div``;

export const DescriptionWrap = styled.div`
  border-bottom: 1px solid #e0e0e0;
  margin-bottom: 20px;
  padding-bottom: 17px;

  @media ${minBp('tabletLarge')} {
    border: 0;
    margin: 0;
    padding: 0;
  }
`;

export const DialogBody = styled.div`
  display: flex;
  flex-direction: column-reverse;
  max-height: 100%;
  overflow-y: auto;
  overflow-x: hidden;

  @media ${minBp('tabletLarge')} {
    flex-direction: column;
    overflow-y: hidden;
  }
`;

export const FilterIcon = styled.div`
  position: relative;

  svg {
    vertical-align: middle;
    width: 32px;
    height: 32px;
  }

  @media ${minBp('tabletLarge')} {
    display: none;
  }
`;

export const ResetFilterButton = styled.button`
  appearance: none;
  border: 0;
  border-radius: 4px;
  padding: 5px 7px;
  font-size: 12px;
  background-color: #eaeaea;
  color: #585a5f;
  position: absolute;
  bottom: 3px;
  right: 0;

  svg {
    width: 14px;
    height: 14px;
    vertical-align: middle;
    position: relative;
    bottom: 2px;
    margin-right: 3px;

    path {
      fill: #585a5f;
    }
  }
`;

export const ScrollIndicator = styled.div`
  position: absolute;
  bottom: 0px;
  left: 0;
  width: 100%;
  height: 25px;
  padding: 3px;
  background-color: #eeeeee;

  svg {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    width: 20px;
    height: 20px;

    path {
      fill: #585a5f;
    }
  }
`;
